<form *ngIf="form" [formGroup]="form">
  <dx-text-box [label]="'common.code' | translate | ucfirst" formControlName="code" formField required></dx-text-box>
  <dx-text-area [label]="'common.name' | translate | ucfirst" formControlName="name" formField required></dx-text-area>
</form>
